webpackJsonp([42329217830356],{

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeadlineWithFocus = __webpack_require__(29);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _reactHelmet = __webpack_require__(56);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box" },
	    _react2.default.createElement(_reactHelmet2.default, { title: "Let's play" }),
	    _react2.default.createElement(
	      _HeadlineWithFocus2.default,
	      null,
	      "About Me"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "I enjoy coding because I can see how little things make a big differences in coding. I first got into software engineering because of high school."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "I have been in Prime Digital Academy for the past 4 months and I have learn the full stack development. It was hard to start from nothing and do a big change of career change."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "One of my hobbies outside of work is cars. Just anything to do with them, like example racing, and talking about the new and old cars or fixing them."
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-playground-jsx-8606aed82fde904360aa.js